// PHX-7000 :: INFO
// Created this for misc functions that don't warrant full fledged helper files and
// which don't fit in with existing files

export const fieldHasValue = (value) => {
  return value !== undefined && value !== null && value !== '';
};
